import { MultiLangString } from "./Models";

export function getValueByLang(multiLangString:MultiLangString, lang:string) {
    return (lang == "my" && multiLangString.my)? multiLangString.my : multiLangString.en;
}